import React from 'react';
import Brick from './BrickCore';
import { ArticlesField, SalepointsField } from '../../components';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * add an article to a cart.
 *
 * [server_side]
 */
class CartAddArticleBrick extends Brick {
    /**
     * @param {{ salepoints?: object[], articles?: object[] }|null|undefined} detailCtx
     * @returns {string|null}
     */
    getNodeDetails(detailCtx) {
        const salepoints = detailCtx?.salepoints || [];
        const articles = detailCtx?.articles || [];
        const salepointId = this.getOption('salepoint_id');
        const articleId = this.getOption('article_id');
        const variantId = this.getOption('variant_id');
        const quantity = this.getOption('quantity');
        const parts = [];

        if (salepointId != null) {
            const salepoint = salepoints.find((s) => String(s?._id) === String(salepointId));
            const salepointLabel = this.localizedDetailLabel(salepoint?.name, detailCtx, '');
            if (salepointLabel)
                parts.push(salepointLabel);
        }

        const findVariant = (allArticles, targetVariantId) => {
            if (targetVariantId == null)
                return { article: null, variant: null };
            const wantedVariantId = String(targetVariantId);
            for (const article of allArticles) {
                const variant = (article?.variants || []).find((v) => String(v?._id) === wantedVariantId);
                if (variant)
                    return { article, variant };
            }
            return { article: null, variant: null };
        };

        let article = articles.find((a) => String(a?._id) === String(articleId));
        if (!article && variantId != null)
            article = findVariant(articles, variantId).article;

        if (articleId != null && article) {
            const articleLabel = this.localizedDetailLabel(article?.name, detailCtx, '');
            if (articleLabel)
                parts.push(articleLabel);
        }

        if (variantId != null) {
            let variant = article?.variants?.find((v) => String(v?._id) === String(variantId));
            if (!variant)
                variant = findVariant(articles, variantId).variant;
            if (variant) {
                const variantLabel = this.localizedDetailLabel(variant?.name, detailCtx, '');
                if (variantLabel)
                    parts.push(variantLabel);
            }
        }

        if (quantity != null && String(quantity) !== '' && String(quantity) !== '1')
            parts.push(`x${quantity}`);

        const singleLine = this.getOption('single_line');
        if (singleLine === true || singleLine === 'true' || singleLine === 1 || singleLine === '1')
            parts.push('1 ligne');

        return this.joinNodeDetailParts(parts);
    }

    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t, salepoints, articles } = props;

        if (!salepoints || !articles)
            return null;

        return (
            <>
                <FormGroup row>
                    <Label for="salepoint_id" className="text-v-center" sm={12}>
                        { t('workflows.bricks.cart.add.article.options.salepoint_id') }
                    </Label>
                    <Col sm={12}>
                        <SalepointsField salepoints={salepoints} name={`bricks[${this.position}].options.salepoint_id`} single />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="article_id" className="text-v-center" sm={12}>
                        { t('workflows.bricks.cart.add.article.options.article_id') }
                    </Label>
                    <Col sm={12}>
                        <ArticlesField onlyArticles articles={articles} name={`bricks[${this.position}].options.article_id`} single />
                    </Col>
                </FormGroup>
                {this.options?.article_id && (
                    <FormGroup row>
                        <Label for="variant_id" className="text-v-center" sm={12}>
                            { t('workflows.bricks.cart.add.article.options.variant_id') }
                        </Label>
                        <Col sm={12}>
                            <ArticlesField articles={articles.filter(a => a._id === this.options.article_id)} name={`bricks[${this.position}].options.variant_id`} single />
                        </Col>
                    </FormGroup>
                )}
                <FormGroup row>
                    <Label for="quantity" className="text-v-center" sm={12}>
                        { t('workflows.bricks.cart.add.article.options.quantity') }
                    </Label>
                    <Col sm={12}>
                        <Field component="input" type="number" name={`bricks[${this.position}].options.quantity`} className="form-control" />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="single_line" className="text-v-center" sm={12}>
                        { t('workflows.bricks.cart.add.article.options.single_line') }
                    </Label>
                    <Col sm={12}>
                        <Field component="select" name={`bricks[${this.position}].options.single_line`} className="form-control">
                            <option value="false">{ t('common.no') }</option>
                            <option value="true">{ t('common.yes') }</option>
                        </Field>
                    </Col>
                </FormGroup>
            </>
        );
    }
}

export default CartAddArticleBrick;
